module.exports = __webpack_public_path__ + "static/img/2.af40ca6.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/pintu/2.jpg
// module id = 06Zh
// module chunks = 1